import React from "react"
import { Field } from "formik"

import { hookOnChangeCustomInput } from "../../utils"
import ReCAPTCHA from "react-google-recaptcha"

const Recaptcha = ({ name, onChange = (...args: any) => {} }: any) => {
  return (
    <Field name={name}>
      {({ field, form }) => {
        return (
          <ReCAPTCHA
            {...field}
            onChange={hookOnChangeCustomInput(form, name, onChange)}
            sitekey={process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY_DEV}
          />
        )
      }}
    </Field>
  )
}

export default Recaptcha
